import { cn } from "@gymflow/helpers";

import CustomTooltip from "../../../../CustomTooltip";
import { CheckIcon } from "../../../../icons";
import { OptionImage } from "../../OptionImage";

export type OptionType<T> = {
  id: string | number;
  label: string;
  subLabel?: string;
  value: T;
  imageUrl?: string;
  disabled?: boolean;
  tooltip?: string;
};

type OptionItemProps<T> = {
  option: OptionType<T>;
  isSelected: boolean;
  onSelect: (option: OptionType<T>) => void;
  withImageByDefault: boolean;
};

export const OptionItem = <T,>({
  option,
  isSelected,
  onSelect,
  withImageByDefault,
}: OptionItemProps<T>) => (
  <CustomTooltip message={option.tooltip} asChild>
    <div
      className={cn(
        "flex min-h-11 cursor-pointer items-center justify-between rounded-[0.625rem] p-1.5 hover:bg-gray-50 dark:hover:bg-gray-900",
        {
          "bg-gray-50 dark:bg-gray-900": isSelected,
          "opacity-50 cursor-not-allowed hover:bg-gray-0 dark:hover:bg-gray-950":
            option.disabled,
        },
      )}
      onClick={() => !option.disabled && onSelect(option)}
    >
      <div className="flex items-center gap-2">
        <OptionImage
          imageUrl={option.imageUrl}
          label={option.label}
          withImageByDefault={withImageByDefault}
        />
        <div className="flex flex-col">
          <div className="dark:text-gray-0 text-sm font-medium text-gray-950">
            {option.label}
          </div>
          {option.subLabel && (
            <div className="text-sm text-gray-500">{option.subLabel}</div>
          )}
        </div>
      </div>
      {isSelected && <CheckIcon pathClassName="stroke-secondary-500" />}
    </div>
  </CustomTooltip>
);
